
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M505.832 269.002c0-39.798-5.306-75.122-15.887-105.985-10.594-30.847-23.05-55.655-39.925-74.402-16.88-18.738-36.738-34.176-59.566-46.286-22.836-12.113-45.171-20.467-67.015-25.094-21.843-4.609-44.346-6.919-67.509-6.919-76.784 0-137.344 22.64-181.678 67.915-44.347 45.288-68.42 107.147-68.42 185.583 0 74.984 23.747 133.964 67.429 176.928 43.682 42.973 103.575 64.452 179.692 64.452 60.22 0 112.836-13.702 157.855-41.09 44.993-27.39 73.837-64.158 89.068-110.31H364.143c-17.866 39.227-53.279 58.825-106.226 58.825-22.509 0-41.198-3.308-56.091-9.945-14.893-6.621-26.154-16.141-33.757-28.55-7.615-12.397-12.906-25.093-15.884-38.068-2.978-12.979-4.809-28.4-5.459-46.287h358.111c.652-6.921.995-13.842.995-20.767zm-357.119-59.693c9.262-70.945 44.333-106.419 105.234-106.419 32.422 0 57.735 9.23 75.951 27.684 18.19 18.467 28.939 44.708 32.261 78.732H148.713v.003z"}})])
          )
        }
      }
    